import React from "react";
import { useFormContext } from "react-hook-form";

import { InputErrorMessage } from "../InputErrorMessage/InputErrorMessage";
import { PaziaTooltip } from "../PaziaTooltip/PaziaTooltip";

import { InputLabel } from "../InputLabel/InputLabel";
export interface PaziaInputProps {
  name: string;
  type?: "text" | "number" | "password" | "file" | "hidden" | "datetime-local";
  label?: string;
  required?: boolean;
  disabled?: boolean;
  hidden?: boolean;
  hideErrors?: boolean;
  className?: string;
  placeholder?: string;
  inputClassName?: string;
  tooltip?: string;
  requiredMessage?: string;
  value?: any;
  lang?: string;
  step?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const PaziaInput = ({
  name,
  label,
  disabled,
  required,
  type = "text",
  className = "",
  placeholder = "",
  inputClassName = "",
  value,
  lang,
  step,
  tooltip,
  hideErrors,
  onBlur,
  onChange,
  hidden,
}: PaziaInputProps): JSX.Element => {
  const { register } = useFormContext();

  const {
    onBlur: onBlurRegister,
    onChange: onChangeRegister,
    ...registerRest
  } = register(name);

  const onBlurHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    if (onBlur) onBlur(e);
    onBlurRegister(e);
  };
  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    if (onChange) onChange(e);
    onChangeRegister(e);
  };

  const additionalInputClasses = disabled ? classNames.disabled : "";
  return (
    <div className={`flex flex-col ${className} ${hidden && "hidden"}`}>
      <InputLabel label={label} required={required} name={name} />
      <div className="flex gap-2">
        <input
          id={name}
          lang={lang}
          hidden={hidden}
          className={`form-input h-[2.375rem] w-full ${additionalInputClasses} ${inputClassName} dark:bg-slate-800`}
          type={type}
          disabled={disabled}
          step={step}
          placeholder={placeholder}
          value={value}
          onChange={onChangeHandler}
          onBlur={onBlurHandler}
          onKeyDown={(
            e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>
          ) => e.key === "Enter" && e.preventDefault()}
          {...registerRest}
        />
        {tooltip && <PaziaTooltip description={tooltip} />}
      </div>
      {!hideErrors && <InputErrorMessage name={name} />}
    </div>
  );
};

const classNames = {
  disabled:
    "disabled:border-slate-200 dark:disabled:border-slate-700 disabled:bg-slate-100 dark:disabled:bg-slate-700 disabled:text-slate-400 dark:disabled:text-slate-600 disabled:cursor-not-allowed",
};
